export var createMuiDialogTitleOverrides = function (_a) {
    var spacing = _a.spacing;
    return {
        styleOverrides: {
            root: {
                padding: spacing(5, 5, 3, 5),
            },
        },
    };
};
